import { makeAutoObservable } from 'mobx';
import appApi from '../api/app-api';
import { ExternalExamGroup } from '../api/types/external-exams/external-exam-group';

class ExternalExamGroupsStore {
  groups: ExternalExamGroup[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  async fetchGroups() {
    const res = await appApi.getExternalExamGroups();
    if (res.data.ok && res.data.body) {
      this.groups = res.data.body;
    }
  }

  addGroup(group: ExternalExamGroup) {
    this.groups.push(group);
  }

  updateGroup(updatedGroup: ExternalExamGroup) {
    const index = this.groups.findIndex((g) => g.id === updatedGroup.id);
    if (index !== -1) {
      this.groups[index] = updatedGroup;
    }
  }

  removeGroup(groupId: number) {
    this.groups = this.groups.filter((g) => g.id !== groupId);
  }

  updateGroupInList(groupId: number, updatedGroup: ExternalExamGroup) {
    const index = this.groups.findIndex((g) => g.id === groupId);
    if (index !== -1) {
      this.groups[index] = updatedGroup;
    }
  }
}

const externalExamGroupsStore = new ExternalExamGroupsStore();
export default externalExamGroupsStore;
